const REPORTS_QUERY_KEY = 'reports';
const REPORTPARAMS_QUERY_KEY = 'reportParams';

const REPORTPARAM_QUERY_KEY = (reportId: string): string[] => [
  REPORTPARAMS_QUERY_KEY,
  reportId
];

export { REPORTS_QUERY_KEY, REPORTPARAM_QUERY_KEY };
